import { useState, useEffect } from "react";

export const Delayed = ({
	children,
	waitBeforeShow = 300,
}: {
	children: any;
	waitBeforeShow?: number;
}) => {
	const [isShown, setIsShown] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsShown(true);
		}, waitBeforeShow);
		return () => clearTimeout(timer);
	}, [waitBeforeShow]);

	return isShown ? children : null;
};

export default Delayed;
